const common = {
  showFilter: true,
  //开发模式下不同
  // basePath: (isDev != undefined && isDev != null && isDev === true) ? '/' : "./",
  basePath: '/',
  operatePermission: {
    ADMIN: { name: '所有', key: '*' },
    QUERY: { name: '查询', key: 'query' },
    ADD: { name: '新增', key: 'add' },
    EDIT: { name: '编辑', key: 'edit' },
    DELETE: { name: '删除', key: 'delete' },
    IMPORT: { key: "import", name: "导入" },
    EXPORT: { key: "export", name: "导出" },
    CONFIG: { key: "config", name: "配置" },
  },
  echartsColor: ['#009AFF', '#ff5722', '#86CF00', '#f6d54a', '#46a5de', '#4777f5', '#a26bff', '#f7bb24', '#6abfff', '#CC66FF', '#FF6699', '#FF9966', '#FFFF99'],
  theme: {
    'darkTheme': {
      name: '暗夜黑',
      themeKey: 'darkTheme',
      themeColor: '#000',
      titleColor: '#FF8000',
      fontColor: '#fff',
      btnColor: '#FF6300',
      chartColor: '#fff',
      mapBgColor: "rgba(255,255,255,0.3)",
      barColors: ['#ff5722', '#f7b824', '#0dc59f', '#04FF00'],
      radarColor: ['#528381', '#2E5F5E', '#5E8786', '#246A68', '#398E8A', '#ccc'],
      visualMapColor: ['#4777f5', '#62ffe0'],
    },
  },
  supportThemes: {
    // 'darkTheme': '暗夜黑',
    'defaultTheme': '紫宸・标准',
    'lightTheme': '素简・纯白',
    'redTheme': '律章・赤红',
    'blueTheme': '瀚澜・渐变蓝',
    'blueWhiteTheme': '清序・蓝白',
    'pinkTheme': '绯叙・柔粉',
  },
  page: {
    pageSizeOpts: [10, 15, 50, 100, 200, 500, 1000],
    pageSize: 10,
    pageable: true
  },
  resCode: {
    SUCCESS: 'success',
    FAIL: 'FAIL',
    TIMEOUT: "000008",
    UNAUTHORIZED: "000009",
    MALICIOUSLY_MODIFIED: "0000010"
  },
  getDate: function (params) {
    if (params != undefined && params != null && params != "") {
      let date = new Date(params)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate() //日   
      let hour = date.getHours() //小时   
      let min = date.getMinutes() //分   
      let sec = date.getSeconds() //秒   
      return year + "-" + (month > 9 ? month : '0' + month) + "-" + (day > 9 ? day : '0' + day) + " " + (hour > 9 ? hour : '0' + hour) + ":" + (min > 9 ? min : '0' + min) + ":" + (sec > 9 ? sec : '0' + sec)
    }
    return null
  },
  getHHMMDDDate: function (params) {
    if (params != undefined && params != null && params != "") {
      let date = new Date(params)
      let hour = date.getHours() //小时   
      let min = date.getMinutes() //分   
      let sec = date.getSeconds() //秒   
      return (hour > 9 ? hour : '0' + hour) + ":" + (min > 9 ? min : '0' + min) + ":" + (sec > 9 ? sec : '0' + sec)
    }
    return null
  },
  getYYYYMMDDDate: function (params) {
    if (params != undefined && params != null && params != "") {
      let date = new Date(params)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate() //日   
      return year + "-" + (month > 9 ? month : '0' + month) + "-" + (day > 9 ? day : '0' + day)
    }
    return null
  },
  nowYMDHMS: function () {
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate() //日   
    let hour = date.getHours() //小时   
    let min = date.getMinutes() //分   
    let sec = date.getSeconds() //秒    
    return year + "" + (month > 9 ? month : '0' + month) + "" + (day > 9 ? day : '0' + day) + (hour > 9 ? hour : '0' + hour) + "" + (min > 9 ? min : '0' + min) + "" + (sec > 9 ? sec : '0' + sec)
  },
  getPageParams: function (columns, page, searchKey) {
    let searchColumns = []
    columns.forEach(element => {
      if (element.key != undefined && element.searchable != false) {
        searchColumns.push(element.key)
      }
    })
    page.searchColumns = searchColumns
    page.searchKey = searchKey
    return page
  },
  /**
     * 数字转成汉字
     * @params num === 要转换的数字
     * @return 汉字
     * */
  getChineseNum: function (num) {
    let changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
    let unit = ['', '十', '百', '千', '万']
    num = parseInt(num)
    let getWan = (temp) => {
      let strArr = temp.toString().split('').reverse()
      let newNum = ''
      let newArr = []
      strArr.forEach((item, index) => {
        newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
      })
      let numArr = []
      newArr.forEach((m, n) => {
        if (m !== '零') numArr.push(n)
      })
      if (newArr.length > 1) {
        newArr.forEach((m, n) => {
          if (newArr[newArr.length - 1] === '零') {
            if (n <= numArr[numArr.length - 1]) {
              newNum += m
            }
          } else {
            newNum += m
          }
        })
      } else {
        newNum = newArr[0]
      }

      return newNum
    }
    let overWan = Math.floor(num / 10000)
    let noWan = num % 10000
    if (noWan.toString().length < 4) {
      noWan = '0' + noWan
    }
    return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
  },
  getFileType: function (fileType) {
    if (fileType.indexOf("image/") >= 0) {
      return 'image'
    } else if (['application/msword;'].indexOf(fileType) >= 0) {
      return 'doc'
    } else if (['application/vnd.openxmlformats-officedocument.wordprocessingml.document;'].indexOf(fileType) >= 0) {
      return 'docx'
    } else if (['application/vnd.ms-excel;'].indexOf(fileType) >= 0) {
      return 'xls'
    } else if (['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;'].indexOf(fileType) >= 0) {
      return 'xlsx'
    } else if (['application/pdf;'].indexOf(fileType) >= 0) {
      return 'pdf'
    } else if (fileType.indexOf("video/") >= 0 || fileType.indexOf('mp4') >= 0) {
      return 'video'
    } else if (fileType.indexOf("audio/") >= 0 || fileType.indexOf('mp3') >= 0) {
      return 'audio'
    }
    return 'unkonw'
  },
  intersection: function (arr1, arr2) {
    return arr1.filter(value => arr2.includes(value))
  },

  /**
 * 根据身份证获取信息
 * @param {*} idNumber 
 * @param {*} type 
 */
  discriCard: function (idNumber, type) {
    //MALE("男"), FEMALE("女")
    if (idNumber && (idNumber.length == 15 || idNumber.length == 18)) {
      switch (type) {
        case 'gender':
          //获取性别
          let genderCode = ""
          if (idNumber.length == 18) { // 二代身份证号码长度为18位（第17位为性别代码）
            genderCode = idNumber.charAt(16, 1)
          } else if (idNumber.length == 15) { // 一代身份证号码长度为15位（第15位为性别代码）
            genderCode = idNumber.charAt(14, 1)
          }
          if (genderCode) {
            if (parseInt(genderCode) % 2 == 1) {
              return "MALE"
              //是男则执行代码 ...
            } else {
              return "FEMALE"
            }
          }
          return "UNKNOWN"
        case 'birthday':
          //获取出生日期
          return idNumber.substring(6, 10) + "-" + idNumber.substring(10, 12) + "-" + idNumber.substring(12, 14)
      }
    } else {
      // 号码错误
    }
  },
  alarmStatus: [{ val: 1, label: "未处理" }, { label: '处理中', val: 2 }, { label: '已处理', val: 0 }, { label: '已关闭', val: -1 }],
  auditStatus: [{ value: 'REFUSED', label: "已拒绝" }, { label: '已通过', value: 'PASSED' }, { label: '待审核', value: 'PENDING_APPROVAL' }, { label: '已关闭', value: 'CANCEL' }],
  usingStatus: [{ value: 'USING', label: "使用中" }, { value: 'TO_BE_CHECKED', label: "待检查" }, { value: 'SCRAPPED', label: "报废" }, { value: 'OVERDUE_INSPECTION', label: "逾期未检查" }],
  processStatus: [{ value: 'AUDITING', label: "待审核" }, { label: '已驳回', value: 'REFUSED' },
  { label: '待整改', value: 'RECTIFYING' }, { label: '待复查', value: 'RECHECKING' },
  { label: '待验收', value: 'ACCEPTING' }, { label: '已验收', value: 'ACCEPTED' },
  { label: '已作废', value: 'CANCELED' }, { label: '已结束', value: 'FINISHED' },
  { label: '已挂起', value: 'SUSPEND' },
  ],
  judgeSign: [{ value: 'EQ', label: "等于" }, { value: 'NQ', label: "不等于" }, { value: 'GT', label: "大于" }, { value: 'LT', label: "小于" }, { value: 'GE', label: "大于等于" }, { value: 'LE', label: "小于等于" }, { value: 'EXIST', label: "存在" }, { value: 'NOTEXIST', label: "不存在" }],
  IMConsultationStatusMap: {
    wait: '等待律师接入',
    in_service: '服务中',
    finish: '服务完成',
    termination: '服务中止'
  },
  SYSTEM_USER_PRE: process.env.VUE_APP_IM_SYSTEM_USER_PRE,
  hangUpTypes: {
    ringing: "代表呼入未接时挂机",
    dialing: "代表呼出未接时挂机",
    inbound: "代表呼入通话，通话中挂断",
    outbound: "代表呼出通话，通话中挂断",
    internalcall: "代表内部通话，通话中挂断",
    agentHeld: "代表咨询通话，通话中挂断",
    meeting: "代表会议或会议中座席状态变化，挂断",
    consulted: "代表被动求助（被咨询通话），挂断",
    monitored: "代表监听，通话中挂断",
    monitoring: "代表发起监听，还未监听成功，挂断",
    bargedIn: "代表强插，通话中挂断",
    coached: "代表耳语座席，进入三方通话，通话中挂断"
  },
  satisfactionResults: {
    1: "满意",
    2: "基本满意",
    3: "不满意"
  },
  // 系统提示音定义
  notifySoundMap: {
    default: require('@/assets/static/audio/yy.mp3'),
    receive: require('@/assets/static/audio/receive.mp3'),
    online: require('@/assets/static/audio/online.mp3'),
    offline: require('@/assets/static/audio/offline.mp3'),
    access: require('@/assets/static/audio/access.mp3'),
    message: require('@/assets/static/audio/qq.mp3'),
    finish: require('@/assets/static/audio/yy.mp3')
  },
  distributionTypes: {
    system: {
      label: "系统派单",
      color: 'red'
    },
    appoint: {
      label: "管理员指派",
      color: '#f90'
    },
    proac: {
      label: "律师抢单",
      color: 'blue'
    }
  },
  /**
   * 深拷贝
   * @param {*} obj 
   * @returns 
   */
  deepClone: function (obj) {
    if (obj === null || typeof obj !== 'object') {
      return obj
    }
    if (obj instanceof Date) {
      return new Date(obj.getTime())
    }

    if (obj instanceof Array) {
      return obj.reduce((arr, item, i) => {
        arr[i] = this.deepClone(item)
        return arr
      }, [])
    }

    if (obj instanceof Object) {
      return Object.keys(obj).reduce((newObj, key) => {
        newObj[key] = this.deepClone(obj[key])
        return newObj
      }, {})
    }
  },
  uuid: function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8)
      return v.toString(16)
    })
  },
  consultationTypes: [{
    label: '法律咨询',
    value: 'legal_consultation',
  }, {
    label: '司法行政业务咨询',
    value: 'sfxz_consultation',
  }],
  practiceStatus: {
    normal_s: {
      label: "正常",
      type: 'success'
    },
    cancellation_s: {
      label: "注销",
      type: 'warning'
    },
    closure_s: {
      label: "停业",
      type: 'danger'
    }
  },
  lawfirmTypes: [{
    label: '合伙律师事务所',
    value: '01',
  }, {
    label: '个人律师事务所',
    value: '02',
  }, {
    label: '国资律师事务所',
    value: '03',
  },],
  changeLogTypes: {
    add: {
      label: "新增",
      type: 'success'
    },
    edit: {
      label: "编辑",
      type: 'warning'
    },
    enable_disable: {
      label: "启禁用",
      type: 'warning'
    },
    del: {
      label: "删除",
      type: 'danger'
    },
    reset_pd: {
      label: "重置密码",
      type: 'warning'
    }
  },
  reportStatus: {
    TO_BE_ISSUED: {
      label: '待提交',
      type: 'warning',
      roles: ['OPERATION_MANAGER', 'admin']
    },
    REJECT: {
      label: "退回待提交",
      type: 'error',
      roles: ['OPERATION_MANAGER', 'admin']
    },
    PENDING_FINANCE_CONFIRMED: {
      label: "待财务确认",
      type: 'warning',
      roles: ['OPERATION_MANAGER', 'TREASURER', 'admin']
    },
    PENDING_LAWYER_CONFIRMED: {
      label: "待律师确认",
      type: 'warning',
      roles: ['admin']
    },
    LAWYER_UPLOAD_INVOICE: {
      label: "待律师上传发票",
      type: 'primary',
      roles: ['admin']
    },
    FINANCE_AUDIT_INVOICE: {
      label: "发票审核",
      type: 'warning',
      roles: ['TREASURER', 'admin']
    },
    LAWYER_REUPLOAD_INVOICE: {
      label: "待律师重传发票",
      type: 'primary',
      roles: ['admin']
    },
    PENDING_DISTRIBUTION: {
      label: "待发放",
      type: 'warning',
      roles: ['admin']
    },
    SETTLED: {
      label: "已结算归档",
      type: 'success',
      roles: ['OPERATION_MANAGER', 'TREASURER', 'admin']
    }
  },
  reportOperationTypes: {
    EDIT_REPORT: {
      label: "运营编辑结算单"
    },
    DELETE_REPORT: {
      label: "删除结算单"
    },
    ISSUE_REPORT: {
      label: "运营提交结算单"
    },
    REVOKE_REPORT: {
      label: "运营撤回结算单"
    },
    FINANCE_CONFIRM_REPORT: {
      label: "财务确认结算单"
    },
    FINANCE_REJECT_REPORT: {
      label: "财务退回结算单"
    },
    LAWYER_CONFIRM_REPORT: {
      label: "律师退回结算单"
    },
    LAWYER_REJECT_REPORT: {
      label: "律师退回结算单"
    },
    LAWYER_UPLOAD_INVOICE: {
      label: "律师上传发票"
    },
    FINANCE_CONFIRM_INVOICE: {
      label: "财务确认发票"
    },
    FINANCE_REJECT_INVOICE: {
      label: "财务退回发票"
    },
    RESET_REPORT: {
      label: "重置结算单"
    }
  },
  schedulingDistributionTypes: {
    grabbing_first: {
      label: "抢单优先",
      color: 'error'
    },
    distribute_first: {
      label: "派单优先",
      color: 'success'
    }
  },
  categoryMap: {
    consultation: {
      label: '咨询台账',
      color: 'success'
    },
    callback: {
      label: '回拨台账',
      color: 'warning'
    },
    followup: {
      label: '回访台账',
      color: 'primary',
      show: false
    },
  },
}

export default {
  install: function (Vue) {
    Object.defineProperty(Vue.prototype, '$common', { value: common })
  },
}